import React from "react";

// material import
import { Grid2, Box, Button, Typography } from "@mui/material";

// project import
import Logo from "../assets/suwa-arana-logo-white.png";
import ICTLogo from "../assets/ICT-logo.jpg";

const Header = ({ title }) => {
  const handleRedirect = () => {
    window.location.href = "https://suwaarana.org/";
  };

  const handleICTRedirect = () => {
    window.location.href = "https://indiracancertrust.org/";
  };

  return (
    <Box>
      <Grid2 item size={{ xs: 12 }} sx={{ height: 44 }} />
      <Grid2 container justifyContent="center">
        <Grid2
          item
          size={{ xs: 8.2 }}
          sx={{ mt: 4, display: "flex", justifyContent: "space-between" }}
        >
          <Box
            onClick={handleRedirect}
            sx={{
              bgcolor: "#8B2757",
              width: 125,
              height: 120,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img
              src={Logo}
              alt="Suwa Arana Logo"
              style={{ maxWidth: "100%", height: "84%" }}
            />
          </Box>
          {title && (
            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                justifyContent: "center",
                flexGrow: 1,
                px: 2,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: "#8B2757",
                  fontWeight: "bold",
                  fontSize: { md: 26, sm: 20 },
                  letterSpacing: 1.5,
                  textAlign: "center",
                }}
              >
                {title}
              </Typography>
            </Box>
          )}
          <Box
            onClick={handleICTRedirect}
            sx={{
              width: 125,
              height: 120,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img src={ICTLogo} style={{ maxWidth: "100%", height: "90%" }} />
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Header;
